<div class="page-container">
    <app-kyc-kyb-header [scope]="scope" [status]="status()" headingLevel="1" [hasBackButton]="true" />
    <ui-card>
        <app-kyc-kyb-instructions [scope]="scope" />
    </ui-card>
</div>
